module.exports = __webpack_public_path__ + "img/sledding.1cd56b39.svg";